<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { computed } from 'vue';

import LegProductsCustomTable from '@/components/customTables/LegProductsCustomTable.vue';
import H3LineNewAirRoadHeader from '@/components/headers/H3LineNewAirRoadHeader.vue';
import * as legProductsCustomTableHelpers from '@/helpers/tables/legProductsCustom';

export interface Props {
  stops: ReadonlyDeep<openapi.AirroadJobDetailedContentOpenapi['stops']>;
}
const props = withDefaults(defineProps<Props>(), {
  stops: () => [],
});

const firstLegProductsCustomTableData = computed(function () {
  return legProductsCustomTableHelpers.getTableData(
    props.stops[0]?.pickup_products,
  );
});

const secondLegProductsCustomTableData = computed(function () {
  return legProductsCustomTableHelpers.getTableData(
    props.stops[1]?.pickup_products,
  );
});

const tablesData = [
  firstLegProductsCustomTableData,
  secondLegProductsCustomTableData,
];
</script>

<template>
  <section :class="$style.legProductsSection" data-testid="legProductsSection">
    <article
      v-for="stopNum in props.stops.length - 1"
      :key="stopNum"
      :class="$style.leg"
    >
      <H3LineNewAirRoadHeader>
        Leg {{ stopNum }} products
      </H3LineNewAirRoadHeader>
      <LegProductsCustomTable :data="tablesData[stopNum - 1].value" />
    </article>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.legProductsSection {
  display: flex;
  gap: 1.5rem;
}
  .leg {
    width: calc(50% - 12px);
  }
</style>
